import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles';

class Counter extends React.Component {
  constructor(props) {
    super(props);
    this.state = { counter: props.val };
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const x = this;
    const { counter } = this.state;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      if (counter > 0) {
        x.setState({ counter: counter - 1 });
        if (counter === 1) {
          this.props.onEnd();
        }
      }
    }, 1000);

    const style = {
      ...styles.counter,
    };
    if (this.props.onClick) {
      style.cursor = 'pointer';
    }

    if (counter) {
      return (
        <div style={style} onClick={this.props.onClick}>
          {counter}
        </div>
      );
    }
    return null;
  }
}

Counter.propTypes = {
  val: PropTypes.number.isRequired,
  onEnd: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

Counter.defaultProps = {
  onClick: null,
};

export default Counter;
